import { Form } from "@amzn/aquila-feedback-web-assets";
import { TextButton } from "@amzn/storm-ui";
import type { FC } from "react";
import React, { useEffect, useState } from "react";
import { useStore } from "zustand";

import { useGetReportIssueForm } from "../../hooks/aquila/reportIssue/useGetReportIssueForm/useGetReportIssueForm";
import { useSubmitReportIssueForm } from "../../hooks/aquila/reportIssue/useSubmitReportIssueForm/useSubmitReportIssueForm";
import { authStore } from "../../store/auth";
import { navigationStore } from "../../store/navigation";
import { AquilaReportIssueTriggerType } from "../../types/aquila";
import { isNotExecuted, isSuccess } from "../../utils/api.utils";
import { isAllInsightsTab } from "../../utils/tab.utils";

const InternalReportIssue: FC = () => {
    const [aquilaConfig] = useStore(authStore, (state) => [
        state.settings.aquilaConfig,
    ]);
    const [activeTab] = useStore(navigationStore, (state) => [state.activeTab]);
    const [
        formConfig,
        getReportIssueFormConfigAsyncStatus,
        getFormConfigAsyncAction,
    ] = useGetReportIssueForm({
        reportIssueFormConfig: aquilaConfig.sidePanelReportIssueConfig,
    });
    const [isFeedbackFormOpen, setIsFeedbackFormOpen] = useState(false);
    const [, submitFormAsyncAction] = useSubmitReportIssueForm({
        reportIssueFormConfig: aquilaConfig.sidePanelReportIssueConfig,
        trigger: isAllInsightsTab(activeTab)
            ? AquilaReportIssueTriggerType.ALL_INSIGHTS_SIDEPANEL
            : AquilaReportIssueTriggerType.YOUR_INSIGHT_DECKS_SIDEPANEL,
    });

    const handleOnSubmit = (formData) => {
        void submitFormAsyncAction.execute(formData);
        setIsFeedbackFormOpen(false);
    };

    const handleOnCancel = () => {
        setIsFeedbackFormOpen(false);
    };

    useEffect(() => {
        if (
            aquilaConfig.sidePanelReportIssueConfig?.configId &&
            isNotExecuted(getReportIssueFormConfigAsyncStatus)
        ) {
            void getFormConfigAsyncAction.execute();
        }
    }, []);

    return isSuccess(getReportIssueFormConfigAsyncStatus) && formConfig ? (
        <>
            <TextButton onClick={() => setIsFeedbackFormOpen(true)}>
                Report an Issue
            </TextButton>
            {isFeedbackFormOpen && (
                <Form
                    {...formConfig}
                    configId={aquilaConfig.sidePanelReportIssueConfig.configId}
                    onSubmit={handleOnSubmit}
                    onCancel={handleOnCancel}
                    isOpen={isFeedbackFormOpen}
                />
            )}
        </>
    ) : (
        <></>
    );
};

export const SidePanelReportIssue = React.memo(InternalReportIssue);
